import React from 'react'
import { Progress, Typography } from 'antd'
import dayjs from 'dayjs'
import { ECampaignChannel, INotificationCampaign } from 'models/notifications'
import styles from '../Notifications.module.scss'
import {
  channelNames,
  channelUnits,
  formatDateTime,
  getCampaignChannels,
  getMorningWait,
  isCampaignActive
} from './broadcast'

const getTitle = (campaign: INotificationCampaign) => {
  const morningWait = getMorningWait(campaign)
  if (morningWait) {
    return `Остаток рассылки уйдёт в 9:00 по времени продавцов, ближайшая отправка — ${formatDateTime(
      morningWait
    )}`
  }
  switch (campaign.status) {
    case 'scheduled':
      return `Рассылка запланирована на ${formatDateTime(
        campaign.scheduled_at ?? campaign.createdAt
      )}`
    case 'queued':
    case 'running':
      return 'Рассылка выполняется'
    case 'completed':
      return 'Рассылка завершена'
    case 'canceled':
      return 'Рассылка отменена'
    default:
      return 'Рассылка завершилась с ошибкой'
  }
}

interface CampaignProgressProps {
  campaign: INotificationCampaign
}

export const CampaignProgress: React.FC<CampaignProgressProps> = ({
  campaign
}) => {
  const now = dayjs()

  return (
    <div className={styles.campaignStatus}>
      <Typography.Text className={styles.campaignTitle}>
        {getTitle(campaign)}
      </Typography.Text>
      {campaign.status === 'scheduled' && (
        <Typography.Text className={styles.campaignMeta}>
          До начала её можно отменить в «Истории».
        </Typography.Text>
      )}
      {campaign.dryRun && (
        <Typography.Text className={styles.campaignMeta}>
          Тестовый сервер: сообщения не отправляются, а только считаются.
          Всплывающее окно создаётся по-настоящему.
        </Typography.Text>
      )}
      {campaign.status !== 'scheduled' && (
        <div className={styles.channelProgressList}>
          {getCampaignChannels(campaign).map((channel) => {
            const done = channel.sent + channel.failed
            const percent = channel.total
              ? Math.round((done / channel.total) * 100)
              : 100
            const waitsMorning =
              isCampaignActive(channel.status) &&
              channel.next_at &&
              dayjs(channel.next_at).isAfter(now)

            return (
              <div key={channel.key} className={styles.channelProgress}>
                <div className={styles.channelProgressHead}>
                  <Typography.Text strong>
                    {channelNames[channel.key]}
                  </Typography.Text>
                  <Typography.Text type='secondary'>
                    {channel.key === ECampaignChannel.POPUP
                      ? `окно создано, увидят ${channelUnits[channel.key](
                          channel.total
                        )}`
                      : `${channel.sent.toLocaleString(
                          'ru-RU'
                        )} из ${channelUnits[channel.key](channel.total)}`}
                    {channel.failed
                      ? ` · не доставлено ${channel.failed.toLocaleString(
                          'ru-RU'
                        )}`
                      : ''}
                    {waitsMorning &&
                      ` · продолжится ${dayjs(channel.next_at).format(
                        'DD.MM в HH:mm'
                      )}`}
                  </Typography.Text>
                </div>
                <Progress
                  percent={percent}
                  showInfo={false}
                  status={
                    channel.status === 'failed'
                      ? 'exception'
                      : channel.status === 'completed'
                      ? 'success'
                      : waitsMorning || channel.status === 'canceled'
                      ? 'normal'
                      : 'active'
                  }
                />
                {channel.error && (
                  <Typography.Text
                    type='danger'
                    className={styles.channelError}
                  >
                    {channel.error}
                  </Typography.Text>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
